@if (scripts) {
  <div [innerHTML]="scripts | safe: 'html'" runScripts="before" [scriptsHtml]="scripts"></div>
}
@if (html) {
  <div [innerHtml]="html | removeElementIfNotAuth | removeModeElements | replaceTokensArray: {keys: tokenArray ?? item}  | safe: 'html' "></div>
}
@if (scripts) {
  <div  [innerHTML]="scripts | safe: 'html'" runScripts="after" [scriptsHtml]="scripts"></div>
}
